<app-product-group-integration-list [productGroupModel]="model" />
